import { Button, Col, Row } from "antd";
import React from "react";

export default function HeaderPage({logoUrl}) {
  let flag = `assets/flag.png`;
  let profile = `assets/ellipse.png`;
  return (
    <Row justify="space-between" align="middle">
      <Col>
        <Row gutter={[16, 0]} align="middle">
          <Col>
            <img src={logoUrl} style={{ width: "61px", objectFit: "cover" }} />
          </Col>
          <Col>
            <img src={flag} style={{ width: "100%", objectFit: "cover" }} />
          </Col>
        </Row>
      </Col>
      <Col>
        <img src={profile} style={{ objectFit: "cover" }} />
      </Col>
    </Row>
  );
}
